import * as ajax from "helpers/ajax";
import { UFFICIO_ID } from "../constant";
import MDInput from "components/MDInput";

export const randomString = (length) => {
	var result           = '';
	var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	var charactersLength = characters.length;
	for ( var i = 0; i < length; i++ ) {
		result += characters.charAt(Math.floor(Math.random() *  charactersLength));
	}
	return result;
};

export const toPrice = (n) => {
    // Converti in numero e gestisci casi null/undefined
    const num = parseFloat(n);
    if (isNaN(num)) return '0,00 €';
    
    // Separa parte intera e decimale
    const parts = num.toFixed(2).split('.');
    const integerPart = parts[0];
    const decimalPart = parts[1];
    
    // Aggiungi i punti per le migliaia
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    
    // Ritorna il valore formattato con virgola per i decimali
    return formattedInteger + ',' + decimalPart + ' €';
}
export const toPercentage = (n) => {
    return (n.toFixed(2) + " %").replace(".",",")
}


export const convertDate = (date) => {
    if (!date) return null;

    var yyyy = date.getFullYear().toString();
    var mm = (date.getMonth() + 1).toString();
    var dd = date.getDate().toString();

    var mmChars = mm.split('');
    var ddChars = dd.split('');

    return yyyy + '-' + (mmChars[1] ? mm : "0" + mmChars[0]) + '-' + (ddChars[1] ? dd : "0" + ddChars[0]);
}

export const toEuropeanDate = (date) => {
    if (!date) return null;
    date=new Date(date)
    var yyyy = date.getFullYear().toString();
    var mm = (date.getMonth() + 1).toString();
    var dd = date.getDate().toString();

    var mmChars = mm.split('');
    var ddChars = dd.split('');

    return (ddChars[1] ? dd : "0" + ddChars[0]) + "/" + (mmChars[1] ? mm : "0" + mmChars[0]) + "/" + yyyy;
}

export const toDashDate = (date) => {
    const [giornoInizio, meseInizio, annoInizio] = date.split('/');
    return `${annoInizio}-${meseInizio}-${giornoInizio}`;
}

export const getBusinessDatesCount = (startDate, duration, returnType = "endDate") => {
    if (!startDate) {
        return 0
    }

    let count = 0;
    let workedDays = 0;

    const curDate = new Date(startDate);
    const endDate = new Date(startDate)
    endDate.setDate(endDate.getDate() + duration);

    while (curDate <= endDate) {
        const dayOfWeek = curDate.getDay();
        if (dayOfWeek !== 0 && dayOfWeek !== 6) {
            count++;
            if (new Date() > curDate) {
                workedDays++;
            }
        } else {
            //festivi
            endDate.setDate(endDate.getDate() + 1);
        }
        curDate.setDate(curDate.getDate() + 1);
    }

    switch (returnType) {
        case "endDate": return endDate;
        case "workingDays": return workedDays;
    }

    return endDate;
}

export const calculateSAL=(data) => {
    let sumIncidenza = 0;
    let numberOfIncidenzaSet = 0;
    let percentage = 0;

    data.map((el) => {
        if (el.incidenza) {
            sumIncidenza += parseFloat(el.incidenza);
            numberOfIncidenzaSet++;
        }
    })

    if (numberOfIncidenzaSet == data.length) {
        data.map((el) => {
            el.incidenza = (parseFloat(el.incidenza) * 100) / sumIncidenza;
            el.incidenza = parseFloat(el.incidenza).toFixed(2)
        })
    }

    data.map((el) => {
        if (!el.incidenza) {
            el.incidenza = (100 - sumIncidenza) / (data.length - numberOfIncidenzaSet);
            el.incidenza = el.incidenza.toFixed(2)
        }
        if (el.incidenza < 0) {
            el.incidenza = (0).toFixed(2)
        }
        percentage += (parseFloat(el.incidenza) * el.percentage / 100)
    })


    if (percentage > 100) { return 100 }
    if (percentage < 0) {return 0}
    return percentage;
}

export const calculateSALAQ = (data) => {
        let n = 0;

        data.map((el, index) => {
            if (!el.sal) { el.sal = [] }
            if (!el.incidenza) { el.incidenza = 0 }
            n += calculateSAL(el.sal) * el.incidenza / 100;
        })
        return n;

}

export const calculateMarkup = (data) => {
    let amount_subjcet_to_discount_C = data.base_amount - data.security
    let amount_discounted_E = amount_subjcet_to_discount_C * data.discount_percentage / 100
    let amount_proposed_F = amount_subjcet_to_discount_C - amount_discounted_E + data.security;
    let markup_price = amount_proposed_F - (data.costo_ordini_preventivato + data.costo_manodopera_preventivato)

    return toPrice(markup_price);
}

export const calculateMarkupReal = (data, materialCost, laborCost, from = null, to = null) => {
    if (from && to) {

        let temp = data.fattures.filter((data) => isBetweenDate(from, to, data.data_fattura))
        let sum = 0;
        temp.map((el) => {
            sum += el.imponibile;
        })
        sum = sum - (materialCost + laborCost);
        return sum;
    }

    
    let sum = 0;
    data.fattures.map((el) => {
        sum += el.imponibile;
    })
    sum = sum - (materialCost + laborCost);

    return sum
}

export const calculateBudgetReal = (data, markupReal, from = null, to = null) => {
    if (from && to) {

        let temp = data.fattures.filter((data) => isBetweenDate(from, to, data.data_fattura))
        let sum = 0;
        temp.map((el) => {
            sum += el.imponibile;
        })
        sum = sum - markupReal;
        return sum;
    }


    let sum = 0;
    data.fattures.map((el) => {
        sum += el.imponibile;
    })
    sum = sum - markupReal;

    return sum
}


export const getWorkedDaysNumber = (data, from = null, to = null) => {

    if (from && to) {
        let temp = data.filter((data) => isBetweenDate(from, to, data.data))
        return [...new Set(temp.map(item => item.data))].length; 
    }


    return [...new Set(data.map(item => item.data))].length; 
}


export const materialCostCommessa = (data, from = null, to = null) => {
    let sum = 0;
    if (!data.fc_ordini) { return sum }

    if (from && to) {
        let temp= data.fc_ordini.filter((data) => data && data.date && isBetweenDate(from, to, data.date))
        temp.map((el) => {
            sum += el.amount_gross
        })

        return sum
    }


    data.fc_ordini.map((el) => {
        sum += el.amount_gross
    })

    return sum
}

export const laborCostCommessa = (data, from = null, to = null, id=null) => {

    if (from && to) {
        let temp = data.filter((data) => isBetweenDate(from, to, data.data))
        return laborCostCommessa(temp,null,null,id);
    }

    let sum = 0;

    let sumType = {
        ordinario: 0,
        straordinario: 0,
        permesso: 0,
        ferie: 0,
        malattia: 0,
        assenza: 0,
        sospeso: 0,
        notturno: 0
    };

    data.map((el) => {
        if (!el.operaio) {return}
        if (el.stato == "ORDINARIO") {
            //sum += (parseFloat(el.operaio.costo_orario) * parseFloat(el.ore))
            sumType.ordinario += el.ore;
        }
        if (el.stato == "STRAORDINARI ") {
            //sum += (parseFloat(el.operaio.costo_straordinario) * parseFloat(el.ore))
            sumType.straordinario += el.ore;
        }
        if (el.stato == "PERMESSO") {
            //sum += (parseFloat(el.operaio.costo_orario) * parseFloat(el.ore))
            sumType.permesso += el.ore;
        }
        if (el.stato == "FERIE") {
            //sum += (parseFloat(el.operaio.costo_orario) * parseFloat(el.ore))
            sumType.ferie += el.ore;
        }
        if (el.stato == "MALATTIA") {
            //sum += (parseFloat(el.operaio.costo_orario) * parseFloat(el.ore))
            sumType.malattia += el.ore;
        }
        if (el.stato == "ASSENZA") {
            //sum += (parseFloat(el.operaio.costo_orario) * parseFloat(el.ore))
            sumType.assenza += el.ore;
        }
        if (el.stato == "SOSPESO") {
            //sum += (parseFloat(el.operaio.costo_orario) * parseFloat(el.ore))
            sumType.sospeso += el.ore;
        }
        if (el.stato == "NOTTURNO") {
            //sum += (parseFloat(el.operaio.costo_notturno) * parseFloat(el.ore))
            sumType.notturno += el.ore;
        }
        if (el.stato == "PATERNITA/MATERNITA") {
            //sum += (parseFloat(el.operaio.costo_orario) * parseFloat(el.ore))
            sumType.sospeso += el.ore;
        }

        sum += newWorkerPrice(el);

    })

    if (id != UFFICIO_ID && id !=null) {
        sum += getOfficeLaborCost(data)
    }
        
    return sum
}




const getOfficeLaborCost = (data) => {
    let dateList = arrOfDate(data)
    let sum = 0;
    dateList.map((date) => {
        //let activeCommessaDay = getActiveCommessaSingleDay(date);
        //sum += getOfficeCostSingleDay(date) / activeCommessaDay;
        let numWorkers = 0;
        data.map((el) => {
            if (date == el.data) {
                numWorkers++;
            }
        })

        sum += getOfficeCostSingleDay(date) * getOfficeCoefficent(date, numWorkers);
        //console.log(getOfficeCoefficent(date,numWorkers), sum, date, data);
    })
    return sum;
}



const getOfficeCostSingleDay = (day) => {
    let sum = 0;
    global.workers.data.map((el) => {
        if (day == el.data && el.commessa) {
            if (el.commessa.id == UFFICIO_ID) {
                if (!el.operaio) { return }
               /* if (el.stato == "ORDINARIO") {
                    sum += (parseFloat(el.operaio.costo_orario) * parseFloat(el.ore))
                }
                if (el.stato == "STRAORDINARI ") {
                    sum += (parseFloat(el.operaio.costo_straordinario) * parseFloat(el.ore))
                }
                if (el.stato == "PERMESSO") {
                    sum += (parseFloat(el.operaio.costo_orario) * parseFloat(el.ore))
                }
                if (el.stato == "FERIE") {
                    sum += (parseFloat(el.operaio.costo_orario) * parseFloat(el.ore))
                }
                if (el.stato == "MALATTIA") {
                    sum += (parseFloat(el.operaio.costo_orario) * parseFloat(el.ore))
                }
                if (el.stato == "ASSENZA") {
                    sum += (parseFloat(el.operaio.costo_orario) * parseFloat(el.ore))
                }
                if (el.stato == "SOSPESO") {
                    sum += (parseFloat(el.operaio.costo_orario) * parseFloat(el.ore))
                }
                if (el.stato == "NOTTURNO") {
                    sum += (parseFloat(el.operaio.costo_notturno) * parseFloat(el.ore))
                }*/
                sum += newWorkerPrice(el);

            }
        }
    })

    return sum
}


const getOfficeCoefficent = (day, commessaTotalWorkers) => {
    let totalWorkers=0
    global.workers.data.map((el) => {
        if (day == el.data && el.commessa) {
            if (el.commessa.id != UFFICIO_ID) {
                totalWorkers++;
            }
        }
    })

    //console.log(commessaTotalWorkers , totalWorkers, commessaTotalWorkers / totalWorkers)

    return commessaTotalWorkers / totalWorkers
}

const getActiveCommessaSingleDay = (day) => {
    let arr = [];
    global.workers.data.map((el) => {
        if (day == el.data && el.commessa) {
            uniqueArray(arr, el.commessa.id);
        }
    })
    
    return arr.length
}



const uniqueArray = (arr, el) => {
    if (arr.indexOf(el) === -1) {
        arr.push(el);
    }
    return arr
}

const arrOfDate = (data) => {
    let arr = [];
    data.map((el) => {
        uniqueArray(arr, el.data);
        uniqueArray(arr, el.data);
    })
    return arr
}


export const filterEmptyWorkers = (data) => {
    let cleanData = data.filter((value) => value.operaio != null);
    return cleanData;
}

function addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
}

export function isFestiveDay(date, festiveDays) {
    const formattedDate = date.toLocaleDateString("en-US", { month: "2-digit", day: "2-digit" });
    const dayOfWeek = date.getDay(); // 0 = Domenica, 1 = Lunedì, ..., 6 = Sabato
    return festiveDays.includes(formattedDate) || dayOfWeek === 0 || dayOfWeek === 6;
}

export const calculateFinalDate = (startDate, durationInDays, excludeFestiveDays = false, returnNumber = false) => {
    if (!startDate) { return "";}

    const festiveDays = ["01/01", "12/25", "12/31", "04/25", "05/01", "06/02", "06/29"]; // Esempio di date festive (mm/gg)

    //const [giornoInizio, meseInizio, annoInizio] = startDate.split('-');
    //let currentDate = new Date(`${meseInizio}/${giornoInizio}/${annoInizio}`);
    //console.log(startDate)


    let currentDate = new Date(startDate)
    let remainingDays = durationInDays;

    let i = durationInDays;
    while (remainingDays > 1) {
        currentDate = addDays(currentDate, 1);
        if (!excludeFestiveDays || !isFestiveDay(currentDate, festiveDays)) {
            remainingDays--;
        } else {
            i--
        }
    }

    if (returnNumber) { return i }
    return toEuropeanDate(currentDate);
}

export const daysBetween=(startDate, endDate)=> {

    const [giornoInizio, meseInizio, annoInizio] = startDate.split('/');
    const [giornoFine, meseFine, annoFine] = endDate.split('/');

    const inizio = new Date(`${meseInizio}/${giornoInizio}/${annoInizio}`);
    const fine = new Date(`${meseFine}/${giornoFine}/${annoFine}`);

    const differenzaInMillisecondi = fine - inizio;

    const differenzaInGiorni = differenzaInMillisecondi / (1000 * 60 * 60 * 24);

    return Math.round(differenzaInGiorni);
}

export const getAQPassedDays = (data) => {
    if (!data.data_inizio) { return 0}
    return daysBetween(toEuropeanDate(data.data_inizio), toEuropeanDate(new Date()));
}

export const calculateImportoContrattuale = (data, price=true) => {
    let importoProposto = data.preventivo;

   /* if (data.gara) {
        let gara = data.gara;
        let amount_subjcet_to_discount_C = gara.base_amount - gara.security
        let amount_discounted_E = amount_subjcet_to_discount_C * gara.discount_percentage / 100
        importoProposto = amount_subjcet_to_discount_C - amount_discounted_E + gara.security;
    }*/

    if (price) { return toPrice(importoProposto) }

    return importoProposto
}

export const getAllMonthsinYear = (from, type = "shortMonth") => {
    let arr = []
    from = new Date(getFirstDateOfMonth(from));
    let max = 12;
    while (max > 0) {
        let month = from.getMonth();
        if (type == "date") {
            arr.push(from.getFullYear() + "-" + ("0" + (from.getMonth() + 1)).slice(-2) + "-01")
        }
        if (type == "MonthNumber") {
            arr.push(month)
        }
        if (type == "shortMonth") {
            switch (month) {
                case 0: arr.push("Gen"); break;
                case 1: arr.push("Feb"); break;
                case 2: arr.push("Mar"); break;
                case 3: arr.push("Apr"); break;
                case 4: arr.push("Mag"); break;
                case 5: arr.push("Giu"); break;
                case 6: arr.push("Lug"); break;
                case 7: arr.push("Ago"); break;
                case 8: arr.push("Set"); break;
                case 9: arr.push("Ott"); break;
                case 10: arr.push("Nov"); break;
                case 11: arr.push("Dic"); break;
            }
        }
        max--;
        from = new Date(from.setMonth(from.getMonth() + 1));
    }
    return arr;
}
export const getAllMonths = (from, type="shortMonth") => {
    let arr=[]
    from = new Date(getFirstDateOfMonth(from)); 
    let max = 15;
    while (from <= new Date() && max > 0) {
        let month = from.getMonth();
        if (type == "date") {
            arr.push(from.getFullYear() + "-" + ("0" + (from.getMonth() + 1)).slice(-2)+"-01")
        }
        if (type == "MonthNumber") {
            arr.push(month)
        }
        if(type=="shortMonth"){
            switch (month) {
                case 0: arr.push("Gen"); break;
                case 1: arr.push("Feb"); break;
                case 2: arr.push("Mar"); break;
                case 3: arr.push("Apr"); break;
                case 4: arr.push("Mag"); break;
                case 5: arr.push("Giu"); break;
                case 6: arr.push("Lug"); break;
                case 7: arr.push("Ago"); break;
                case 8: arr.push("Set"); break;
                case 9: arr.push("Ott"); break;
                case 10: arr.push("Nov"); break;
                case 11: arr.push("Dic"); break;
            }
        }
        max--;
        from = new Date(from.setMonth(from.getMonth() + 1));
    }
    return arr;
}

export const shortMonthName = (month) => {
    switch (month) {
        case 0: return("Gen"); break;
        case 1: return("Feb"); break;
        case 2: return("Mar"); break;
        case 3: return("Apr"); break;
        case 4: return("Mag"); break;
        case 5: return("Giu"); break;
        case 6: return("Lug"); break;
        case 7: return("Ago"); break;
        case 8: return("Set"); break;
        case 9: return("Ott"); break;
        case 10: return("Nov"); break;
        case 11: return("Dic"); break;
    }
    return ""
}

function isBetweenDate(startDate, endDate, date) {
    let current = new Date(date);

    return new Date(startDate) <= current && new Date(endDate) >= current;
}

export const getLastDateOfMonth = (date) => {
    date = new Date(date);
    let last = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    return last.getFullYear() + "-" + ("0" + (last.getMonth() + 1)).slice(-2) + "-" + ("0" + (last.getDate())).slice(-2)
}

export const getFirstDateOfMonth = (date) => {
    date = new Date(date);
    let last = new Date(date.getFullYear(), date.getMonth() , 1);

    return last.getFullYear() + "-" + ("0" + (last.getMonth() + 1)).slice(-2) + "-" + ("0" + (last.getDate())).slice(-2)
}

export const getLastDateOfMonthBefore = (date) => {
    date = addDays(date, -1);
    return date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + (date.getDate())).slice(-2)
}


export const isAccordoQuadro=(data)=>{
    if (data.gara) {
        if (data.gara.contract_type == "Accordo Quadro") {
            return true
        }
    }
    return false
}


export const workerPriceByWorkType = (type, worker) => {
    switch (type) {
        case "STRAORDINARI ": return worker.costo_straordinario; 
        case "NOTTURNO": return worker.costo_notturno; 
    }

    return worker.costo_orario;
}

export const newWorkerPrice = (el, includeFiller = true) => {
    let baseCost = 0;
    
    // Se l'operaio è somministrato, il costo è 0
    if (el.operaio && el.operaio.tipo_contratto === "Somministrato") {
        return 0;
    }
    
    if (el.costo_orario) {
        baseCost = el.costo_orario * el.ore;
    } else {
        if (el.stato == "ORDINARIO") {
            baseCost = (parseFloat(el.operaio.costo_orario) * parseFloat(el.ore));
        }
        if (el.stato == "STRAORDINARI ") {
            baseCost = (parseFloat(el.operaio.costo_straordinario) * parseFloat(el.ore));
        }
        if (el.stato == "PERMESSO") {
            baseCost = (parseFloat(el.operaio.costo_orario) * parseFloat(el.ore));
        }
        if (el.stato == "FERIE") {
            baseCost = (parseFloat(el.operaio.costo_orario) * parseFloat(el.ore));
        }
        if (el.stato == "MALATTIA") {
            baseCost = (parseFloat(el.operaio.costo_orario) * parseFloat(el.ore));
        }
        if (el.stato == "ASSENZA") {
            baseCost = (parseFloat(el.operaio.costo_orario) * parseFloat(el.ore));
        }
        if (el.stato == "SOSPESO") {
            baseCost = (parseFloat(el.operaio.costo_orario) * parseFloat(el.ore));
        }
        if (el.stato == "NOTTURNO") {
            baseCost = (parseFloat(el.operaio.costo_notturno) * parseFloat(el.ore));
        }
        if (el.stato == "PATERNITA/MATERNITA") {
            baseCost = (parseFloat(el.operaio.costo_orario) * parseFloat(el.ore));
        }
    }

    // Aggiungi il costo del filler usando sempre il costo ordinario dell'operaio (solo se includeFiller=true)
    if (includeFiller && el.filler && el.filler > 0 && el.operaio) {
        const costoOrdinario = parseFloat(el.operaio.costo_orario);
        baseCost += el.filler * costoOrdinario;
    }

    return baseCost;
}

export const combineDateAndTime = (date, time) => {
    let dateStr = toEuropeanDate(date)
    let timeStr = time.slice(0,5)

    return dateStr + " " + timeStr;
}

export const DipendenteOrConsulenteName = (row) => {
    let s = "";
    if (row.user_type) {
        if (row.user_type == "Dipendenti") {
            if (row.dipendente) {
                s = row.dipendente.nome + " "+row.dipendente.cognome;
            }
        }
        if (row.user_type == "Consulenti") {
            if (row.consulente) {
                s = row.consulente.nome + " " + row.consulente.cognome;
            }
        }
    }

    return s
}

export const calcolaDifferenzaTempo=(data_inizio, ora_inizio, data_fine, ora_fine)=> {
    const inizio = new Date(`${data_inizio}T${ora_inizio}`);
    const fine = new Date(`${data_fine}T${ora_fine}`);

    const diffMs = fine - inizio;

    if (diffMs < 0) {
        return "-";
    }

    const diffGiorni = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    const diffOre = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));

    let risultato = "";
    if (diffGiorni > 0) {
        risultato += `${diffGiorni} giorni`;
    }
    if (diffOre > 0) {
        risultato += (risultato ? " e " : "") + `${diffOre} ore`;
    }

    return risultato || "0 ore"; // fallback se entrambi sono 0
}

export const operaioFullName = (row) => {
    if (!row.operaio) { return "" }
    return row.operaio.nome + " " + row.operaio.cognome;
}

export const commessaName = (row) => {
    if (!row.commessa) { return "" }
    return row.commessa.nome;
}

export const missingHours = (row) => {
    if (!row.ore && !row.totalHours) { return "" }

    // Use totalHours if available, otherwise use ore
    const hours = row.totalHours !== undefined ? row.totalHours : row.ore;
    return 8 - hours;
}

export const noteInline= (row) => {
    const saveNote = (value) => {
        const updateData = {
            data: { note: value }
        };
        
        ajax.ajaxPutStrapi(`operai-commesses/${row.id}`, updateData, (response) => {

        });
    };

    return (
        <MDInput
            multiline={true}
            rows={1}
            label={""}
            type={"text"}
            defaultValue={row.note || ""}
            fullWidth
            onBlur={(e) => { 
                saveNote(e.target.value);
            }}
        />
    );
}

export const calculateSALHierarchical = (salList) => {
    if (!salList || salList.length === 0) return 0;

    // First organize into hierarchy
    const salMap = {};
    const rootSALs = [];

    // Create a map of all SALs
    salList.forEach(sal => {
        salMap[sal.id] = { ...sal, children: [] };
    });

    // Organize into hierarchy
    salList.forEach(sal => {
        if (sal.parent && sal.parent.id && salMap[sal.parent.id]) {
            salMap[sal.parent.id].children.push(salMap[sal.id]);
        } else {
            rootSALs.push(salMap[sal.id]);
        }
    });

    // Calculate parent percentages and incidences from bottom up
    const calculateParentValues = (salList) => {
        salList.forEach(sal => {
            if (sal.children && sal.children.length > 0) {
                // First calculate for children recursively
                calculateParentValues(sal.children);
                
                // For parents: calculate values from direct children only
                let totalWeightedPercentage = 0;
                let totalIncidenza = 0;
                
                sal.children.forEach(child => {
                    // Use the child's incidenza and percentage (original for leaf, calculated for parents)
                    const childIncidenza = child.incidenza || 0;
                    const childPercentage = child.percentage || 0;
                    totalWeightedPercentage += (childPercentage * childIncidenza);
                    totalIncidenza += childIncidenza;
                });
                
                // Parent's incidenza is sum of direct children's incidences
                sal.incidenza = totalIncidenza;
                
                // Parent's percentage is weighted average of direct children
                if (totalIncidenza > 0) {
                    sal.percentage = Math.round(totalWeightedPercentage / totalIncidenza);
                    sal.completed = sal.percentage >= 100;
                } else {
                    sal.percentage = 0;
                    sal.completed = false;
                }
            }
            // For leaf nodes, keep their original incidenza and percentage
        });
    };

    calculateParentValues(rootSALs);

    // Calculate final weighted average from leaf nodes only
    const getLeafNodes = (salList) => {
        let leafNodes = [];
        const collectLeaves = (items) => {
            items.forEach(item => {
                if (!item.children || item.children.length === 0) {
                    leafNodes.push(item);
                } else {
                    collectLeaves(item.children);
                }
            });
        };
        collectLeaves(salList);
        return leafNodes;
    };

    const leafNodes = getLeafNodes(rootSALs);

    // Calculate final result from leaf nodes only
    let totalWeightedPercentage = 0;
    let totalIncidenza = 0;
    
    leafNodes.forEach(sal => {
        const incidenza = sal.incidenza || 0;
        const percentage = sal.percentage || 0;
        totalWeightedPercentage += (percentage * incidenza);
        totalIncidenza += incidenza;
    });
    
    return totalIncidenza > 0 ? totalWeightedPercentage / totalIncidenza : 0;
};

export const calculateSALSimple = (salList) => {
    if (!salList || salList.length === 0) return 0;
    
    let totalWeightedPercentage = 0;
    let totalIncidenza = 0;
    
    salList.forEach(sal => {
        const incidenza = sal.incidenza || 0;
        const percentage = sal.percentage || 0;
        totalWeightedPercentage += (percentage * incidenza);
        totalIncidenza += incidenza;
    });
    
    return totalIncidenza > 0 ? totalWeightedPercentage / totalIncidenza : 0;
};